import { Button, Modal } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { CREDIT_RATINGS } from '@app/configs/creditRating';
const CreditRatingModal = ({ closeModal, isOpen }) => {
    const { t } = useTranslation();
    return (<Modal open={isOpen} size="md" className="!min-w-0 !max-w-[min(540px,calc(100vw-32px))]" onClose={closeModal} heading={t('financing.credit_rating.modal_title')} footer={<Button variant="secondary" label={t('financing.evaluation_complete.close')} onClick={closeModal}/>}>
            <div className="space-y-4 text-neutral-secondary-initial body-m">
                {CREDIT_RATINGS.map((rating) => (<div key={rating.titleKey}>
                        <p className="font-bold">{t(rating.titleKey)}</p>
                        <p className="font-normal">{t(rating.descriptionKey)}</p>
                    </div>))}
            </div>
        </Modal>);
};
export default CreditRatingModal;
